import { createClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL
const key = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!url || !key) {
  // Loud and early — better than a silent 401 later.
  // eslint-disable-next-line no-console
  console.error('[supabase] missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY in .env.local')
}

export const supabase = createClient(url, key, {
  auth: {
    // Session lives in localStorage and is renewed silently: users stay
    // signed in until they tap "Sign out" (Supabase refresh tokens don't
    // expire on their own).
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true, // needed for reset-password redirect flow
  },
})
